import { Calendar, CircleUser } from "lucide-react";
import Tooltip from "./Tooltip";
import { formatTimestamp } from "@/utils/timeFormatting";

type CreateMetaDataProps = {
  createdAt: Date | null;
  createdBy: string;
  withTimestamp?: boolean;
};
export const CreateMetaData = ({
  createdAt,
  createdBy,
  withTimestamp = false,
}: CreateMetaDataProps) => {
  const formatDate = (date: Date | null) => {
    if (!date) return "-";
    if (withTimestamp) {
      return formatTimestamp(date);
    }
    return date.toLocaleDateString();
  };

  return (
    <div className="flex items-center gap-4 text-gray-500 font-mono">
      <Tooltip
        asChild
        trigger={
          <span className="flex items-end gap-1">
            <Calendar className="w-4 h-4" />
            <span className="text-xs leading-4">{formatDate(createdAt)}</span>
          </span>
        }
        content="Created At"
      />
      <Tooltip
        asChild
        trigger={
          <span className="flex gap-1">
            <CircleUser className="w-4 h-4" />
            <span className="text-xs">{createdBy}</span>
          </span>
        }
        content="Created By"
      />
    </div>
  );
};
